<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 48 48"
    height="48"
    width="48">
    <g :fill="fill">
      <path
        d="M44,22a2,2,0,0,0-2,2v8a2,2,0,0,1-2,2H15V28a1,1,0,0,0-1.588-.809l-11,8a1,1,0,0,0,0,1.618l11,8A1,1,0,0,0,15,44V38H40a6.006,6.006,0,0,0,6-6V24A2,2,0,0,0,44,22Z"
        :fill="_secondaryfill"></path>
      <path
        d="M45.588,11.191l-11-8A1,1,0,0,0,33,4v6H8a6.006,6.006,0,0,0-6,6v8a2,2,0,0,0,4,0V16a2,2,0,0,1,2-2H33v6a1,1,0,0,0,1.588.809l11-8a1,1,0,0,0,0-1.618Z"
        :fill="fill"></path>
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    fill: {
      type: String,
      default: 'currentColor'
    },
    secondaryfill: {
      type: String
    }
  },
  computed: {
    _secondaryfill: function () {
      return this.secondaryfill || this.fill
    }
  }
}
</script>
